export default "__VITE_ASSET__BaFMZSgE__"